import { getDateDifference } from './experience-formula';

interface ITDS_INTEREST_RATES {
  taxDeductedAmount?: number;
  typeOfInterestCalculation: string;
  dateOfAmountPayment?: string;
  endDateOfTaxDeduction?: string;
  dateOfTaxDeduction?: string;
  endDateOfTaxPayment?: string;
  startDateOfReturnFiling?: string;
  endDateOfReturnFiling?: string;
}

type TDS_INTEREST = { interest: number };

export const TDS_INTEREST_RATE_CALCULATOR_FORMULA = ({
  taxDeductedAmount,
  typeOfInterestCalculation,
  dateOfAmountPayment,
  endDateOfTaxDeduction,
  dateOfTaxDeduction,
  endDateOfTaxPayment,
  startDateOfReturnFiling,
  endDateOfReturnFiling,
}: ITDS_INTEREST_RATES): TDS_INTEREST => {
  if (!taxDeductedAmount || !typeOfInterestCalculation) {
    return { interest: 0 };
  }

  let interest = 0;

  switch (typeOfInterestCalculation) {
    case 'LATE_DEDUCTION': {
      if (!dateOfAmountPayment || !dateOfTaxDeduction) {
        break;
      }

      const dueDate = new Date(dateOfAmountPayment);
      const deductionDate = new Date(dateOfTaxDeduction);

      const yearDiff = deductionDate.getFullYear() - dueDate.getFullYear();
      const monthDiff = deductionDate.getMonth() - dueDate.getMonth();
      const monthsLate = yearDiff * 12 + monthDiff;

      interest = taxDeductedAmount * 0.01 * Math.max(0, monthsLate);
      break;
    }

    case 'LATE_PAYMENT': {
      if (
        !endDateOfTaxDeduction ||
        !endDateOfTaxPayment ||
        !taxDeductedAmount
      ) {
        break;
      }

      const dateDiff = getDateDifference(
        endDateOfTaxDeduction,
        endDateOfTaxPayment
      );
      const monthsLate =
        dateDiff.years * 12 + dateDiff.months + (dateDiff.days > 0 ? 1 : 0);

      interest = taxDeductedAmount * 0.015 * monthsLate;
      break;
    }

    case 'LATE_FILING': {
      if (!endDateOfReturnFiling || !startDateOfReturnFiling) {
        return { interest: 0 };
      }
      const totalDays =
        (new Date(endDateOfReturnFiling).getTime() -
          new Date(startDateOfReturnFiling).getTime()) /
        (1000 * 60 * 60 * 24); // converting time in milliseconds to days

      const dailyFee = 200;
      const daysLate = totalDays;
      interest = daysLate * dailyFee;

      // Ensure interest does not exceed the tax deducted amount
      interest = interest > taxDeductedAmount ? taxDeductedAmount : interest;
      break;
    }

    default:
      interest = 0;
  }

  return { interest: Math.max(0, interest) };
};
